/**
 * Created by Pradeep Kumar on 6/06/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfNefertitiGameConfig} from "../TombOfNefertitiGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfNefertitiGameAssets} from "../TombOfNefertitiGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class TombOfNefertitiLogo extends BaseView {

    private _logo: PIXI.Sprite;
    private _logoPortrait: PIXI.Sprite;

    constructor() {
        super();

        const layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.LOGO.name);

        layer.addChild(this);
    }

    protected initAnimations(): void {
        const offsetYPortrait: number = -170;

        this._logo = new PIXI.Sprite(GameResources.getTextures(TombOfNefertitiGameAssets.INTRO_LOGO)[0]);

        this._logoPortrait = new PIXI.Sprite(GameResources.getTextures(TombOfNefertitiGameAssets.INTRO_LOGO)[0]);

        this._logo.position.set((TombOfNefertitiGameConfig.instance.GAME_WIDTH - this._logo.width) / 2, 0);
        this.addChild(this._logo);

        this._logoPortrait.position.set((TombOfNefertitiGameConfig.instance.GAME_WIDTH) / 2, -this._logoPortrait.height / 4 + offsetYPortrait);
        this._logoPortrait.scale.set(2.75);
        this._logoPortrait.anchor.set(0.5);
        this.addChild(this._logoPortrait);
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.PORTRAIT) {
            this._logo.visible = false;

            this._logoPortrait.visible = true;
        } else {
            this._logo.visible = true;

            this._logoPortrait.visible = false;
        }
    }
}